import { ProjectFiles } from "./ProjectFiles"
import { Tag, Space, Flex, Typography } from "antd"
import { ProjectDetail } from "./ProjectDetail"
import {
  FolderOpenOutlined,
  UserOutlined,
  PhoneOutlined,
  HomeOutlined,
  ToolOutlined,
  FileFilled,
} from "@ant-design/icons"

const { Text } = Typography
export const renderFileButton = (row, { props, setErrorMessage }) => {
  return (
    <ProjectFiles
      rowData={row}
      mainProps={props}
      setErrorMessage={setErrorMessage}
    />
  )
}

export const renderFloorNumber = row => {
  if (row.floorNumber == 0 && row.unitNumber == 1) return <small>همکف</small>
  if (row.floorNumber == 0 && row.unitNumber > 1)
    return <small>چند واحدی</small>
  return row.floorNumber
}

export const renderExeFullName = (row, props) => {
  return row.executor.fullName
}

export const renderRowNumber = (index, { pageIndex, pageSize }) => {
  return (pageIndex - 1) * pageSize + index + 1
}

// Export a function called renderDetailButton that takes in two parameters, params and props
export const renderDetailButton = (params, { props }) => {
  // Return a ProjectDetail component with the rowData and mainProps props set to the params and props parameters respectively, and the isReadOnly prop set to true if the projectLevelEnum property of params is equal to 2
  return (
    <ProjectDetail
      rowData={params}
      mainProps={props}
      isReadOnly={params.projectLevelEnum === 2}
    />
  )
}

export const projectColumnsAnt = props => {
  return [
    // Column 1: File Number & Owner
    {
      title: (
        <Flex align="center" gap={4}>
          <FolderOpenOutlined style={{ color: "#667eea" }} />
          <span>پرونده</span>
        </Flex>
      ),
      key: "fileNumber",
      render: params => (
        <div
          style={{
            background: params.isCancel ? "#fff2f0" : "#f6f8fa",
            borderRadius: 8,
            padding: "8px 10px",
            border: params.isCancel ? "1px solid #ffccc7" : "1px solid #e8e8e8",
          }}
        >
          {/* File Number */}
          <Text style={{ fontSize: 12, cursor: "pointer" }}>
            1001 {params.fileNumber}
            <FileFilled style={{ marginLeft: 4, color: "#8c8c8c" }} />
          </Text>

          {/* Owner Name */}
          <div style={{ marginTop: 4 }}>
            <Text style={{ fontSize: 12 }}>
              {params.landlordName}
              <UserOutlined style={{ marginLeft: 4, color: "#8c8c8c" }} />
            </Text>
          </div>

             {/* city  Name */}
          <div style={{ marginTop: 4 }}>
            <Text style={{ fontSize: 12 }}>
              {params.address}
              <UserOutlined style={{ marginLeft: 4, color: "#8c8c8c" }} />
            </Text>
          </div>

          {/* Owner Phone Number */}
          <div>
            {params.landlordPhoneNumber ? (
              <a
                href={`tel:${params.landlordPhoneNumber}`}
                style={{ color: "inherit", textDecoration: "none" }}
              >
                <Text style={{ fontSize: 12, cursor: "pointer" }}>
                  {params.landlordPhoneNumber}
                  <PhoneOutlined style={{ marginLeft: 4, color: "#8c8c8c" }} />
                </Text>
              </a>
            ) : (
              <Text style={{ fontSize: 12 }}>
                <PhoneOutlined style={{ marginLeft: 4, color: "#8c8c8c" }} />-
              </Text>
            )}
          </div>

          {/* Landlord National Code */}
          <div style={{ marginTop: 4 }}>
            <Text style={{ fontSize: 12 }}>
              {params.landlordNaCode}
              <UserOutlined style={{ marginLeft: 4, color: "#8c8c8c" }} />
            </Text>
          </div>

          {/* Status Tag */}
          <div style={{ marginTop: 6 }}>
            <Tag
              color={params.isCancel ? "error" : "processing"}
              style={{ borderRadius: 4, fontSize: 10 }}
            >
              {params.isCancel
                ? +params.disapprovalTypeEnum === 0
                  ? params.projectLevel
                  : params.disapprovalTypeName
                : params.projectLevel}
            </Tag>
          </div>
        </div>
      ),
    },

    // Column 5: Actions (Files, Engineer, Installer)
    {
      title: (
        <Flex align="center" gap={4}>
          <ToolOutlined style={{ color: "#722ed1" }} />
          <span>عملیات</span>
        </Flex>
      ),
      key: "actions",
      render: params => (
        <Space
          direction="vertical"
          size={4}
          align="center"
          style={{ width: "100%" }}
        >
          {renderFileButton(params, props)}
          <Tag
            color={
              params.buildingType === "تجاری"
                ? "cyan"
                : params.buildingType === "صنعتی"
                ? "orange"
                : "default"
            }
            style={{ borderRadius: 4, fontSize: 10 }}
          >
            {params.buildingType}
          </Tag>
           <Text type="secondary" style={{ fontSize: 9 }}>
            {params.inspectionParameterType}
          </Text>
        </Space>
      ),
    },
  ]
}
